import React, {useEffect, useState} from 'react';
import {Modal} from "../../../../components/modal/modal.jsx";
import Button from "../../../../components/button/button.jsx";
import {FaEraser, FaSearch} from "react-icons/fa";
import SentryRow from "../../../../components/template/sentry-row.jsx";
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";

const initialState = {
    dtIni: "",
    dtEnd: "",
    important: "all",
    favorite: "all",
    status: "all"
}

const options = [
    {value: "all", label: "Todos"},
    {value: "true", label: "Sim"},
    {value: "false", label: "Não" }
]

const UserMessagesFilterModal = ({open, closeModal, filters, setFilters, viewSent}) => {
    const [state, setState] = useState(initialState)

    useEffect(() => {
        if (!open || !filters) {
            setState(initialState);
            return;
        }

        setState(filters);
    }, [open]);

    const clear = () => {
        setState(initialState);
        setFilters(undefined);
    }

    return (
        <Modal open={open} setOpen={closeModal} title={"Filtrar lista de mensagens"} overflow={true} className={"w-[45rem]"}>
            <Modal.Body>
                <SentryRow>
                    <div className={"col-span-12 flex items-stretch"}>
                        <div className="relative flex-1">
                            <InputDateTime
                                id={"dtIni"}
                                selected={state.dtIni}
                                label={"Data/hora do envio"}
                                onChange={(date) => setState(prev => ({...prev, dtIni: date }))}
                                classNameWrapper={"right-date-input"}
                                dateFormat={"LL"}
                            />
                        </div>
                        <div className="border border-[#E5E7EB] px-4 py-2 text-sm leading-none">à</div>
                        <div className="relative flex-1">
                            <InputDateTime
                                id={"dtEnd"}
                                selected={state.dtEnd}
                                label={""}
                                onChange={(date) => setState(prev => ({...prev, dtEnd: date }))}
                                classNameWrapper={"left-date-input"}
                                dateFormat={"LL"}
                            />
                        </div>
                    </div>

                    <SelectComponent
                        classNameWrapper={"col-span-12"}
                        value={state.important}
                        options={options}
                        label={"Importante"}
                        onChange={(value) => setState(prev => ({...prev, important: value?.value}))}
                        isClearable={false}
                    />

                    {
                        !viewSent &&
                        <>
                            <SelectComponent
                                classNameWrapper={"col-span-12"}
                                value={state.favorite}
                                options={options}
                                label={"Favoritado"}
                                onChange={(value) => setState(prev => ({...prev, favorite: value?.value}))}
                                isClearable={false}
                            />

                            <SelectComponent
                                classNameWrapper={"col-span-12"}
                                value={state.status}
                                options={[
                                    {value: "all", label: "Todos"},
                                    {value: "VIEWED", label: "Visualizados"},
                                    {value: "NEW", label: "Novos"},
                                ]}
                                label={"Status"}
                                onChange={(value) => setState(prev => ({...prev, status: value?.value}))}
                                isClearable={false}
                            />
                        </>
                    }
                </SentryRow>
            </Modal.Body>
            <Modal.Footer className={"flex gap-2"}>
                <Button target={"default"} onClick={clear}>
                    <FaEraser /> Limpar
                </Button>
                <Button onClick={() => setFilters(state)}>
                    <FaSearch /> Pesquisar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default UserMessagesFilterModal;